import $ from 'jquery';

$('.site-header .header__nav > .menu-item > .sub-menu').hover(
    function() {
        $(this).parent('.menu-item').addClass('js-hover');
    }, function() {
        $(this).parent('.menu-item').removeClass('js-hover');
    }
)